import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'currencySeperator'})
export class CurrencySeperatorPipe implements PipeTransform {
  transform(val: number): any {
    if(!val) return val;
    if(val > 9999999999) return val;
    if (val <= 0) return val;
    var nonDecimal = Math.floor(val);
    var value = val.toString();
    var pos = value.length-1
    var ret = "";
    for(var i=value.length-1; i>=0; i--) {
        if(value[i] === '.') {
            pos = i-1;
            break;
        }
    }
    if(pos !== value.length-1) {
        for(var i=pos+3; i>pos; i--) {
            if(i >= value.length) ret += "0";
            else ret += value[i]
        }
    }
    var cnt = 0;
    for(var i=pos, cnt = 0; i>=0; i--, cnt++) {
      if(cnt%3 == 0 && cnt && value[i] != '-') ret += "'";
      ret += value[i];
    }
    return ret.split("").reverse().join("");
  }
}

